import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SimpleNav from '@/components/SimpleNav';
import { useForgotPasswordStore } from '@/store/forgotPassword';
import { ModalType, useModalStore } from '@/store/modal';
import { EyeCross } from '@/svg';

const PasswordResetNewPass = () => {
  const open = useModalStore((state) => state.open);
  const close = useModalStore((state) => state.close);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [uid, setUid] = useState('');
  const [token, setToken] = useState('');

  const createNewPassword = useForgotPasswordStore((state) => state.createNewPassword);

  const isPasswordValid = useCallback(() => {
    const length = password.length >= 12;
    const containLettersAndNumbers = /^(?=.*[A-Za-z])(?=.*\d)(?!.*\s).+$/.test(password);
    const mixOfUpperAndLower = password !== password.toLowerCase() && password !== password.toUpperCase();
    const match = password === confirmPassword;
    return [length, containLettersAndNumbers, mixOfUpperAndLower, match];
  }, [password, confirmPassword]);

  const navigate = useNavigate();

  useEffect(() => {
    const url = window.location.href;

    const uid = url?.split('uid=')[1]?.split('&token=')[0];
    const token = url?.split('token=')[1];
    setUid(uid);
    setToken(token);
  }, []);

  const submitHandler = async () => {
    const res = await createNewPassword({ uid, token, new_password1: password, new_password2: confirmPassword });
    if (res) {
      open(ModalType.SetPasswordSuccess);
      setTimeout(() => {
        close();
        navigate('/login');
      }, 2000);
    }
  };
  return (
    <div className="flex flex-col min-h-screen">
      <SimpleNav heading="會員密碼重設" />
      <div className="flex-1 bg-smoke flex justify-center items-center">
        <div className="bg-white w-[867px] h-[487px] px-11 py-9 max-w-[90%] mx-auto rounded-[20px]">
          <div className="flex items-center gap-[34px]">
            <h3 className="font-istok-web text-[32px] font-bold tracking-[0.96px] leading-[22px] text-navy-blue">
              會員密碼設定
            </h3>
            <hr className="border-navy-blue border-[0.7px] flex-1" />
          </div>
          <div className="w-full flex flex-col flex-1 max-w-[377px] mx-auto gap-[18px] mt-16">
            <div className="flex items-center gap-3 border focus-within:border-2 border-[#B3B4B4] active:border-navy-blue focus-within:border-navy-blue rounded-[10px] px-5">
              <input
                className="font-istok-web text-navy-blue h-[50px] py-2.5 text-xl rounded-[10px] w-full outline-none"
                placeholder="輸入新的密碼"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className="cursor-pointer">
                <EyeCross onClick={() => setShowPassword(!showPassword)} />
              </span>
            </div>
            <div className="flex items-center gap-3 border focus-within:border-2 border-[#B3B4B4] focus-within:border-navy-blue rounded-[10px] px-5">
              <input
                className="font-istok-web text-navy-blue h-[50px] py-2.5 text-xl rounded-[10px] w-full outline-none"
                placeholder="再次輸入新的密碼"
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span className="cursor-pointer">
                <EyeCross onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
              </span>
            </div>
            <div>
              <p className="text-base text-black leading-normal">密碼需滿足以下要求：</p>
              <div className="flex items-center gap-1">
                <img
                  src={
                    isPasswordValid()[0]
                      ? '/images/password-reset/password-tick-black.svg'
                      : '/images/password-reset/password-tick.svg'
                  }
                  alt=""
                />
                <p className={classNames('text-sm leading-normal', isPasswordValid()[0] ? 'text-black' : 'text-grey')}>
                  至少12個字元
                </p>
              </div>
              <div className="flex items-center gap-1">
                <img
                  src={
                    isPasswordValid()[1]
                      ? '/images/password-reset/password-tick-black.svg'
                      : '/images/password-reset/password-tick.svg'
                  }
                  alt=""
                />
                <p className={classNames('text-sm leading-normal', isPasswordValid()[1] ? 'text-black' : 'text-grey')}>
                  至少含字母和數字，不能包含空格
                </p>
              </div>
              <div className="flex items-center gap-1">
                <img
                  src={
                    isPasswordValid()[2]
                      ? '/images/password-reset/password-tick-black.svg'
                      : '/images/password-reset/password-tick.svg'
                  }
                  alt=""
                />
                <p className={classNames('text-sm leading-normal', isPasswordValid()[2] ? 'text-black' : 'text-grey')}>
                  混和使用大小寫字母、數字，使密碼更加安全。
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              {/* <button
                className="font-istok-web rounded-[14px] text-xl font-bold h-[40px] border-navy-blue border text-navy-blue flex-1"
                onClick={() => open(ModalType.SetPasswordSuccess)}
              >
                取消
              </button> */}
              <button
                disabled={
                  !isPasswordValid()[0] || !isPasswordValid()[1] || !isPasswordValid()[2] || !isPasswordValid()[3]
                }
                className="font-istok-web rounded-[14px] text-xl font-bold h-[40px] bg-navy-blue disabled:bg-silk-blue text-white flex-1"
                onClick={submitHandler}
              >
                確認
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetNewPass;
